// Tiny class-name concatenator. Skips falsy values so conditional classes
// can be passed inline.
export default function clsx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
